module.exports = __webpack_public_path__ + "06021ff7516ffe406d29a7c7e2c1310c.png";